import { Dialog } from '@material-ui/core';

import * as S from './styles';

interface Props {
  aberto: boolean;
  telValue: string;
  mensagem: string;
  onChangeTel: (event: { target: { value: string } }) => void;
  onSubmitTel: () => void;
  onFechar: () => void;
}

function CallbackModal({ aberto, telValue, mensagem, onChangeTel, onSubmitTel, onFechar }: Props) {
  return (
    <Dialog open={aberto} onClose={onFechar} maxWidth="xs" fullWidth>
      <S.ModalContent>
        <S.ModalTitle>Deixe seu número</S.ModalTitle>
        <S.ModalText>Informe seu telefone e nós ligamos para você.</S.ModalText>

        <form
          onSubmit={(event) => {
            event.preventDefault();
            onSubmitTel();
          }}
        >
          <S.ModalField
            type="tel"
            inputMode="numeric"
            placeholder="(00) 00000-0000"
            aria-label="Telefone"
            value={telValue}
            onChange={onChangeTel}
          />
          <S.ModalSubmit type="submit" disabled={telValue.replace(/\D/g, '').length < 10}>
            Enviar
          </S.ModalSubmit>
        </form>

        {mensagem && <S.ModalMessage>{mensagem}</S.ModalMessage>}
      </S.ModalContent>
    </Dialog>
  );
}

export default CallbackModal;
